'use client';

import { c as _c } from "react/compiler-runtime";
import { NumberField } from '@base-ui/react';
import type { NumberInputAnswer } from '@repo/contracts/cardfinder/funnel/types';
import { css } from '@repo/pandacss/css';
import { visuallyHidden } from '@repo/pandacss/patterns';
import { useEffect } from 'react';
import type { NumberStep as NumberStepConfig } from '@/features/funnel/config/types';
import { useAnswer, useIsAnswerHydrated } from '@/features/funnel/state/answer/hooks';
import { FUNNEL_STEP_TITLE_ID } from '../../Wrapper/StepTitle';
import { FORMAT_MAPPER } from './utils';
type NumberInputProps = {
  step: NumberStepConfig;
};
export function NumberInput(t0) {
  const $ = _c(24);
  const {
    step
  } = t0;
  const {
    value,
    setAnswer
  } = useAnswer(step.id);
  const isHydrated = useIsAnswerHydrated();
  const format = FORMAT_MAPPER[step.format];
  const numberFormat = new Intl.NumberFormat("en-US", format);
  let t1;
  if ($[0] !== isHydrated || $[1] !== setAnswer || $[2] !== step.defaultValue || $[3] !== value) {
    t1 = () => {
      if (!isHydrated) {
        return;
      }
      if (value === undefined && step.defaultValue !== undefined) {
        setAnswer(step.defaultValue);
      }
    };
    $[0] = isHydrated;
    $[1] = setAnswer;
    $[2] = step.defaultValue;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isHydrated) {
    t2 = [isHydrated];
    $[5] = isHydrated;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      flexDirection: "column",
      gap: "3"
    });
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = value ?? null;
  const t5 = step.min ?? 0;
  let t6;
  if ($[8] !== setAnswer) {
    t6 = v => setAnswer(v ?? undefined);
    $[8] = setAnswer;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = css({
      width: "[100%]"
    });
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      width: "[100%]",
      p: "3",
      height: "[46px]",
      rounded: "md",
      border: "[1px solid {colors.neutral.lighter}]",
      bg: "common.white",
      textStyle: "body",
      lineHeight: "body",
      transition: "[border-color 150ms, background-color 150ms]",
      _focus: {
        outline: "[2px solid {colors.blues.focus}]",
        outlineOffset: "[-2px]"
      },
      _placeholder: {
        color: "neutral.dark"
      }
    });
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== step.placeholder) {
    t9 = <NumberField.Input className={t8} tabIndex={0} placeholder={step.placeholder} aria-labelledby={FUNNEL_STEP_TITLE_ID} />;
    $[12] = step.placeholder;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== format || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t9) {
    t10 = <NumberField.Root value={t4} min={t5} locale="en-US" format={format} onValueChange={t6} className={t7}>{t9}</NumberField.Root>;
    $[14] = format;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = step.suggestions && step.suggestions.length > 0 && <fieldset className={css({
    display: "flex",
    flexWrap: "wrap",
    gap: "2",
    width: "[100%]",
    border: "none",
    padding: "0",
    margin: "0"
  })}><legend className={visuallyHidden()}>Quick amounts</legend>{step.suggestions.map(suggestion => <button key={suggestion} type="button" onClick={() => setAnswer(suggestion)} aria-pressed={value === suggestion} aria-label={`Set amount to ${numberFormat.format(suggestion)}`} className={css({
      flex: "1",
      h: "[32px]",
      py: "1",
      px: "2",
      minWidth: "[70px]",
      maxWidth: "[150px]",
      border: "[1px solid {colors.neutral.lighter}]",
      rounded: "full",
      bg: "common.white",
      cursor: "pointer",
      textStyle: "body.small",
      transition: "all",
      _hover: {
        borderColor: "blues.focus"
      }
    })}>{numberFormat.format(suggestion)}</button>)}</fieldset>;
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t3) {
    t12 = <div className={t3}>{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t3;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}